<template lang="pug">
  div(v-if="product")
    div(v-if="loading.isFetching")
      label.qty-label(v-if="size === 'sm' && !productData.is_in_stock")
        font-awesome-icon(:icon=['far', 'circle-notch'] spin)
      button(v-if="size !== 'sm'" disabled="disabled" :class="buttonClasses")
        font-awesome-icon.mr-2(:icon="['far', 'circle-notch']" spin)
    div(v-if="!loading.isFetching")
      label.qty-label(v-if="size === 'sm' && !productData.is_in_stock && !hideWarning")
        font-awesome-icon.mr-2.text-primary(:icon=['far', 'exclamation-circle'])
        | {{ trans('labels.frontend.product-list.limited') }}
      div(v-if="(productData && productData.is_in_stock)")
        label.qty-label(v-if="size === 'sm' && !hideLabel") {{ trans('labels.frontend.product-list.qty') }}
        .row.align-items-center(v-if="!hideInput")
          .col-auto
            .product-single__item-quantity
              .quantity-box.quantity-box-lg
                button.quantity-box__button.quantity-box__button--minus(
                  type='button' @click="onQtyMinus"
                  :disabled="loading.isAdding || loading.isFetching || disabled || (productData && !productData.is_in_stock)"
                ) -
                input.quantity-box__input(
                  type='number', :min='product.unit_factor', :step='product.unit_factor', :placeholder='product.unit_factor' v-model="quantity"
                  @keyup="onKeyUp" @blur="onBlur" @focus="onFocus"
                  :disabled="loading.isAdding || loading.isFetching || disabled || (productData && !productData.is_in_stock)"
                )
                button.quantity-box__button.quantity-box__button--plus(
                  type='button' @click="onQtyPlus"
                  :disabled="loading.isAdding || loading.isFetching || disabled || (productData && !productData.is_in_stock)"
                ) +
          .col
            small.text-danger.d-block.mb-3(v-if="this.quantity && (this.quantity % this.productData.unit_factor !== 0)") สินค้าจำหน่ายเต็มแพ็ค
      .row
        .col-7.mb-2.mb-md-0(v-if="buyNow && productData.is_in_stock")
          a.btn.btn-block.btn-lg.btn-primary(@click.prevent="addToCart" href="#" :disabled="loading.isAdding || loading.isFetching || disabled || quantity < 1")
            span
              | {{ trans('labels.frontend.product-list.buy-now') }}
        .col-5(v-bind:class="{'col-12': !buyNow || !productData.is_in_stock}")
          a(
            @click.prevent="addToCart({ redirect: false })" href="#"
            :disabled="loading.isAdding || loading.isFetching || disabled || quantity < 1" :class="buttonClasses"
            v-if="productData && productData.is_in_stock"
          )
            span(v-if="(loading.isAdding || loading.isFetching) && !status.isAdded")
              font-awesome-icon.mr-2(:icon="['far', 'circle-notch']" spin)
            span(v-if="status.isAdded")
              font-awesome-icon.mr-2(:icon="['far', 'check']")
            span(v-if="!loading.isAdding && !loading.isFetching && !status.isAdded")
              font-awesome-icon.mr-2(:icon="['far', 'shopping-cart']")
              | {{ trans('labels.frontend.product-single.add-to-cart') }}
          a(
            :class="buttonClasses"
            :href="size === 'sm' ? '/shop/product/' + productData.item_code : 'https://line.me/ti/p/~@spabattery'" target="_blank"
            v-if="productData && !productData.is_in_stock"
            @click="onInquiryClick"
          )
            font-awesome-icon.mr-2(:icon=['fab', 'line'] v-if="size !== 'sm'")
            span(v-if="size !== 'sm'") {{ trans('labels.frontend.product-single.more-details') }}
            span(v-if="size === 'sm'") {{ trans('labels.frontend.product-list.more-details') }}
</template>

<script>
import Cleave from 'vue-cleave-component';
import { RepositoryFactory } from "../../../repositoryFactory";
import notify from '../../notify';
import ConversionManager from '../../../mixins/ConversionManager';

const CancelToken = window.axios.CancelToken;
const AxiosSource = CancelToken.source();

const ProductRepository = RepositoryFactory.get('product');

export default {
  components: {
    Cleave,
  },
  mixins: [ConversionManager],
  props: {
    product: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonClasses: {
      type: String,
      default: 'btn btn-primary btn-block btn-lg btn--add-to-cart'
    },
    size: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    buyNow: {
      type: Boolean,
      default: false,
    },
    showQtyWarning: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    hideInput: {
      type: Boolean,
      default: false,
    },
    hideWarning: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      productData: false,
      loading: {
        isAdding: false,
        isFetching: false,
      },
      status: {
        isAdded: false,
      },
      quantity: 1,
    };
  },
  created() {
    if (this.product) {
      this.getProduct();
    }
  },
  watch: {
    product() {
      this.getProduct();
    }
  },
  methods: {
    onQtyPlus() {
      if (!this.quantity) {
        this.quantity = 0;
      }
      this.quantity = parseInt(this.quantity) + (this.productData.unit_factor);
      this.$emit('updated', this.quantity);
    },
    onQtyMinus() {
      if (!this.quantity) {
        this.quantity = 1;
      }
      if (this.quantity === 1 || this.quantity === this.productData.unit_factor) return;
      this.quantity = parseInt(this.quantity) - (this.productData.unit_factor);
      this.$emit('updated', this.quantity);
    },
    onKeyUp() {
      if (this.quantity != '') {
        this.$emit('updated', this.quantity);
      }
    },
    onBlur() {
      if (this.quantity % this.productData.unit_factor === 0) {
      } else {
        this.quantity = this.round(this.quantity, this.productData.unit_factor, 0);
        this.$emit('updated', this.quantity);
      }
    },
    onFocus() {
      this.quantity = '';
    },
    round(number, increment, offset) {
      return Math.ceil((number - offset) / increment ) * increment + offset;
    },
    async addToCart(options) {
      this.loading = { ...this.loading, ...{ isAdding: true } };
      this.status = { ...this.status, ...{ isAdded: false } };
      if ((this.quantity * this.productData.weight) > 20000) {
        notify.message(this, { title: Lang.get('alerts.frontend.cart.overweight'), text: false }, 'danger');
        this.loading = { ...this.loading, ...{ isAdding: false } };
        return;
      }

      try {
        const { data } = await this.$store.dispatch('cart/add', {
          cart_id: this.$store.getters['cart/id'],
          item_code: this.product.item_code,
          quantity: this.quantity,
          redirect: options.redirect ?? true,
        });
        if (typeof options.redirect === 'undefined' || options.redirect === true) {
          this.trackEvent('Conversion', 'Buttons', 'Buy Now', 'Product Single (Buy Now)', 1);
        } else {
          this.trackEvent('Conversion', 'Buttons', 'Add to Cart', 'Product Single (Add to Cart)', 1);
        }
        this.$emit('added', data);
        this.status = { ...this.status, ...{ isAdded: true } };
        setTimeout(() => {
          this.status = { ...this.status, ...{ isAdded: false } }
        }, 1000);
        notify.success(this, { title: Lang.get('alerts.frontend.general.added_to_cart'), text: false });
      } catch (e) {
        console.log(e);
        notify.errors(this, e);
      }
      this.loading = { ...this.loading, ...{ isAdding: false } };
    },
    async getProduct() {
      this.loading = { ...this.loading, ...{ isFetching: true } };
      try {
        const {data} = await ProductRepository.getStock(this.product.item_code, {
          lang: this.$store.getters['auth/user'].locale ?? 'th',
          cancelToken: AxiosSource.token,
        }).then((resp) => resp.data);
        this.quantity = data.unit_factor;
        this.$emit('updated', this.quantity);
        this.productData = {...this.productData, ...data};
      } catch (e) {
        console.log(e);
      }
      this.loading = { ...this.loading, ...{ isFetching: false } };
    },
    onInquiryClick() {
      this.trackEvent('Click', 'Buttons', 'Add Line', 'Add Line (Product)', 1);
    },
  },
};
</script>
